var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.376577 9.63388C0.87868 10.122 1.69275 10.122 2.19485 9.63388L9 3.01777L15.8051 9.63388C16.3073 10.122 17.1213 10.122 17.6234 9.63388C18.1255 9.14573 18.1255 8.35427 17.6234 7.86612L9.90914 0.366117C9.40703 -0.122038 8.59297 -0.122038 8.09086 0.366117L0.376577 7.86612C-0.125526 8.35427 -0.125526 9.14573 0.376577 9.63388Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.20823893a6c3554a4e6fab6b7eb7eaaa.svg";
export { ForwardRef as ReactComponent };